import { render } from "./card.vue?vue&type=template&id=426f522e&scoped=true"
const script = {}

import "./card.vue?vue&type=style&index=0&id=426f522e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426f522e"]])

export default __exports__